import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import Menu from 'material-ui/svg-icons/navigation/menu';
import { white } from 'material-ui/styles/colors';
import urlBase from '../../url-base';

class HeaderNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: ''
    };
  }

  componentWillMount() {
    const type = localStorage.getItem('dental_y');
    const types = {
      'ADMIN': 'ADMINISTRADOR',
      'REGISTER': 'CADASTRO',
      'AFTER SALES': 'PÓS VENDA',
      'BROKER': 'CORRETORA',
      'SALESMAN': 'VENDEDOR',
      'SUPERVISOR': 'SUPERVISOR',
      'ACCREDITED': 'CREDENCIADOS',
      'BACKOFFICE': 'BACKOFFICE',
      'PJCADASTRO': 'PEJOTA'
    };
    
    this.setState({ userType: types[type] || '' });
  }

  render() {
    const { styles, handleChangeRequestNavDrawer } = this.props;

    const customStyles = {
      appBar: {
        position: 'fixed',
        top: 0,
        height: 64, // Aumentado levemente para melhor respiro
        backgroundColor: '#a8243e',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center'
      },
      titleContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        cursor: 'default'
      },
      logo: {
        height: 35, // Ajuste conforme seu arquivo de imagem
        marginRight: 15,
        objectFit: 'contain'
      },
      separator: {
        width: 1,
        height: 24,
        backgroundColor: 'rgba(255,255,255,0.3)',
        marginRight: 15
      },
      textLabel: {
        color: white,
        fontSize: 14,
        fontFamily: 'RubikRegular',
        letterSpacing: '0.5px',
        textTransform: 'uppercase'
      }
    };

    // Construção do Título com Logo
    const TitleElement = (
      <div style={customStyles.titleContainer}>
        {/* Espaço para o Logo - Substitua o src pela sua imagem 

        <img 
          src={require('../../assets/images/logo-white.png')} 
          style={customStyles.logo} 
          alt="Logo"
        />
        */}
        <div style={customStyles.separator} />
        
        <div style={customStyles.textLabel}>
          {this.state.userType === "PEJOTA" 
            ? `Gestão de Vendas ${this.state.userType}`
            : `Gestão de Vendas - ${this.state.userType}`}
        </div>
      </div>
    );

    return (
      <AppBar
        style={{ ...styles, ...customStyles.appBar }}
        title={TitleElement}
        iconElementLeft={
          <IconButton onClick={handleChangeRequestNavDrawer}>
            <Menu color={white} />
          </IconButton>
        }
        iconElementRight={
          <IconMenu
            iconButtonElement={
              <IconButton><MoreVertIcon color={white} /></IconButton>
            }
            targetOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            <MenuItem 
              primaryText="Sair" 
              containerElement={<Link to={urlBase.client + "panel/logout"} />} 
            />
          </IconMenu>
        }
      />
    );
  }
}

HeaderNew.propTypes = {
  styles: PropTypes.object,
  handleChangeRequestNavDrawer: PropTypes.func
};

export default HeaderNew;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/HeaderNew.js
 **/